// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n[data-v-ccb95cc4]:root{\n  --header-height-sm:80px;\n  --header-height:96px\n}\nimg[data-v-ccb95cc4]{\n  opacity:0;\n  transition-property:opacity;\n  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration:300ms;\n  transition-duration:500ms\n}\nimg.lazy-loaded[data-v-ccb95cc4]{\n  opacity:1\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
